import { render, staticRenderFns } from "./TarjetasComercio.vue?vue&type=template&id=acb27edc&scoped=true&"
import script from "./TarjetasComercio.vue?vue&type=script&lang=js&"
export * from "./TarjetasComercio.vue?vue&type=script&lang=js&"
import style0 from "./TarjetasComercio.vue?vue&type=style&index=0&id=acb27edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb27edc",
  null
  
)

export default component.exports